var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "picture",
    {
      staticClass: "lazy-img",
      staticStyle: { "min-height": "1rem" },
      style: _vm.style,
      attrs: { "data-alt": _vm.alt },
    },
    [
      _vm.isPreviewLoading
        ? _c("span", { staticClass: "loading-indicator icon-loading" })
        : _vm._e(),
      _vm._v(" "),
      _c("img", {
        staticClass: "low-resolution blurred",
        class: { "preview-loaded": !_vm.isPreviewLoading },
        attrs: {
          width: _vm.width ? _vm.width + "px" : "",
          height: _vm.height ? _vm.height + "px" : "",
        },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "full-resolution",
        class: { "image-loaded": !_vm.isLoading },
        attrs: {
          width: _vm.width ? _vm.width + "px" : "",
          height: _vm.height ? _vm.height + "px" : "",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }